import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useLang } from "../context/LangContext";
import { useCart } from "../context/CartContext";
import { ProductCard } from "../components/store/ProductCard";

export default function Wishlist() {
  const { t } = useLang();
  const { wishlist } = useCart();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!wishlist.length) {
      setItems([]);
      return;
    }
    api.get("/products", { params: { ids: wishlist.join(",") } }).then((r) => setItems(r.data));
  }, [wishlist]);

  return (
    <div data-testid="wishlist-page" className="container-q pb-28 pt-16">
      <h1 className="mb-12 text-4xl sm:text-5xl">{t("wishlist")}</h1>
      {!items.length ? (
        <div className="py-16">
          <p data-testid="wishlist-empty" className="font-display text-2xl">{t("wishlist_empty")}</p>
          <Link to="/shop/all" className="btn-line mt-8">{t("continue_shopping")}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 gap-x-5 gap-y-12 sm:gap-x-8 lg:grid-cols-4">
          {items.map((p) => <ProductCard key={p.id} p={p} />)}
        </div>
      )}
    </div>
  );
}
